export const NotAuthorized = (): JSX.Element => {
    return <h2>Invalid permissions for this route.</h2>;
};
